var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',{attrs:{"title":"Page Not Found"}}),_c('p',[_vm._v("The page you're looking for could not be found.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }